import { BsGlobe } from "react-icons/bs";
import { MdOutlineMail } from "react-icons/md";
import meroshare from "../../assets/navbar/meroshare.png";
import connectips from "../../assets/navbar/connectips.png";
import "./onlineDropdown.scss";

const OnlineDropdown = () => {
  return (
    <div className="loginDropCompContainer onlineDropdown">
      <div className="item">
        <a
          href="https://online.icfcbank.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* <BsGlobe size={20} /> */}
          <p>
            Online Account Opening
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://online.icfcbank.com/status/verification"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* <MdOutlineMail size={22} /> */}
          <p>
            Online Account Opening (Tracking)
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://ekyc.icfcbank.com/kyc/full/verify"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* <MdOutlineMail size={22} /> */}
          <p>
            Online eKYC
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://online.icfcbank.com/documents/verification"
          target="_blank"
          rel="noopener noreferrer"
        >
          <p>
            Online Document Verification
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://ekyc.icfcbank.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <p>
            Online Document Collection
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
      </div>
    </div>
  );
};

export default OnlineDropdown;
